<template>
<div class="chapter">
<div class="inner_page">
<a id="page_vi"></a>
<h2 class="fm-title">List of Illustrations</h2>
<p class="illu"><span class="illu1">Cover:</span> Portrait of John Lovell VII and John Siferwas. (<em class="italic">British Library British Library, Harley 7026, fol. 4, verso, © Bridgeman Images</em>)</p>
<p class="illu"><span class="illu1">1.</span> Chateau Ivry-la-Bataille. (<em class="italic">I, Nitot;</em> https://commons.wikimedia.org/wiki/)</p>
<p class="illu"><span class="illu1">2.</span> Titchmarsh Castle. (<em class="italic">Author</em>)</p>
<p class="illu"><span class="illu1">3.</span> Miniature of John Lovell VII and Maud Holland, Lovell Lectionary. (<em class="italic">British Library British Library, Harley 7026, fol. 5, verso © Bridgeman Images</em>)</p>
<p class="illu"><span class="illu1">4.</span> Seals of Maud Holland her three sons. (© <em class="italic">The National Archives TNA E42/278</em>)</p>
<p class="illu"><span class="illu1">5.</span> Coats of arms used by the Lovell family. (<em class="italic">© Gill Smith</em>)</p>
<p class="illu"><span class="illu1">6–8.</span> Old Wardour Castle. (<em class="italic">Author</em>)</p>
<p class="illu"><span class="illu1">9–10.</span> Minster Lovell. (<em class="italic">Author</em>)</p>
<p class="illu"><span class="illu1">11.</span> The tomb of John Lovell IX. (<em class="italic">© Tim Sutton</em>)</p>
<p class="illu"><span class="illu1">12.</span> Francis Lovell’s letters to his ‘cousin’ Wiliam Stonor. (<em class="italic">© The National Archives SC 1/46/102</em>)</p>
<p class="illu"><span class="illu1">13.</span> Francis Lovell’s Garter Stall Plate. (<em class="italic">Public Domain, digitized by Google</em>)</p>
<p class="illu"><span class="illu1">14.</span> Albrecht Dürer’s portrait of Henry Parker, Lord Morley. (<em class="italic">© The Trustees of the British Museum</em>)</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Illustrations.vue?2c66d23f